import api from './api';

export default {
  // --- Groups L1 ---
  async getGroups() {
    const { data } = await api.get('/admin/occupation-groups');
    return data;
  },

  async getGroupSubfamilies(groupId) {
    const { data } = await api.get(`/admin/occupation-groups/${groupId}/subfamilies`);
    return data;
  },

  async getAllSubfamilies() {
    const { data } = await api.get('/admin/occupation-subfamilies');
    return data;
  },

  // --- Roles L3 ---
  async getRoles(params = {}) {
    const { data } = await api.get('/admin/occupation-roles', { params });
    return data;
  },

  async getRole(id) {
    const { data } = await api.get(`/admin/occupation-roles/${id}`);
    return data;
  },

  async createRole(payload) {
    const { data } = await api.post('/admin/occupation-roles', payload);
    return data;
  },

  async updateRole(id, payload) {
    const { data } = await api.patch(`/admin/occupation-roles/${id}`, payload);
    return data;
  },

  // --- Skills sur un rôle ---
  async addRoleSkill(roleId, payload) {
    const { data } = await api.post(`/admin/occupation-roles/${roleId}/skills`, payload);
    return data;
  },

  async updateRoleSkill(roleId, skillId, payload) {
    const { data } = await api.patch(`/admin/occupation-roles/${roleId}/skills/${skillId}`, payload);
    return data;
  },

  async removeRoleSkill(roleId, skillId) {
    const { data } = await api.delete(`/admin/occupation-roles/${roleId}/skills/${skillId}`);
    return data;
  },

  // --- ESCO Enrichment ---
  async getEscoSuggestions(roleId) {
    const { data } = await api.get(`/admin/occupation-roles/${roleId}/esco-suggestions`);
    return data;
  },
};
